export const PREMIUM_UPSELL_WIDGET_SHOWN_STORAGE_KEY =
  'premium-upsell-widget-shown';
export const PREMIUM_ASIA_UPSELL_WIDGET_SHOWN_STORAGE_KEY =
  'premium-asia-upsell-widget-shown';
